$(function() {
	// deleteCookie('STYXKEY_CTA_POPUP');
	var body = $('body');
    var page_id = 0;

    if(body) {
		var classList = body.attr('class').split(/\s+/);

		$.each(classList, function(index, item) {
			if (item.indexOf('page-id') >= 0) {
				var item_arr = item.split('-');
				page_id =  item_arr[item_arr.length -1];
				return false;
			}
		});
	}

	var initPopup = function() {
		var popup = $('.popup_trigger');
		if (!popup.length) return;

		var popup_container = $('#popup');
		var popup_frequency = $('#popup').attr('data-popup-frequency') || 1;
		var popup_id = $('#popup').attr('data-popup-id');

		var cookie = getCookie('STYXKEY_CTA_POPUP');

		if (window.location.pathname == '/gallery/')
			return

		// console.log(cookie, popup_id, popup_frequency);
		// cookie = null;

		// if (!cookie || cookie != popup_id) {
		// 	getCookie
		// 	console.log(cookie, popup_id, popup_frequency);
		// } else {
		// 	return;
		// }

		if (popup_container.hasClass("template_1")) {
			popup.modaal({
				hide_close: true,
				background: '#0E2B4C',
				overlay_opacity: .9,
				// after_close: function(){ document.location.href = "#"; }
			});

			var scrollTop = 0;
			var activatePopup = function() {
				scrollTop = $(window).scrollTop();
				popup.trigger('click');

				setTimeout(function() {

					var close = $('.close_popup, .close_popup_x');
					var button = $('.popup_content a.orange');

					button.click(function() {
						createCookie('STYXKEY_CTA_POPUP', popup_id, popup_frequency / 24);
					});

					close.focus();
					close.click(function() {
						createCookie('STYXKEY_CTA_POPUP', popup_id, popup_frequency / 24);
						popup.modaal('close');
						console.log(cookie, popup_id, popup_frequency);
						setTimeout(function() {
							$(window).scrollTop(scrollTop);
						});
						return false;
					});

				}, 500);
			}

			var interval = setInterval(function() {
				if ($('body').hasClass('load_step_3') && !cookie ) {
					clearInterval(interval);
					activatePopup();
				}
			}, 100);
		}

		if (popup_container.hasClass("template_2")) {
			$('header').after(popup_container);
			var activatePopup = function() {
				var close = $('.close_popup, .close_popup_x');
				popup_container.addClass("popup_open");

				var button = $('.popup_content a.orange');

					button.click(function() {
						createCookie('STYXKEY_CTA_POPUP', popup_id, popup_frequency / 24);
					});

				setTimeout(function() {
					close.addClass("show_close");
				}, 2500);

				var closePopup = function(){
					close.focus();
					popup_container.removeClass("popup_open");
					popup_container.find('.popup_content *').attr('tabindex', -1);
					createCookie('STYXKEY_CTA_POPUP', popup_id, popup_frequency / 24);
					return false;
				}

				close.click(function() {
					closePopup();
					console.log(cookie, popup_id, popup_frequency);
				});

				// $(window).on('scroll', function(){
				// 	var scrollTop = $(window).scrollTop();

				// 	if (scrollTop > 200) {
				// 		closePopup();
				// 	}
				// });
			}

			var interval = setInterval(function() {
				if ($('body').hasClass('reveal_alerts') && !cookie || !cookie  ) {
					setTimeout(function() {
						clearInterval(interval);
						activatePopup();
					}, 500);
				}
			}, 500);
		}
	}

	$.get('/get-current-popup?id=' + page_id, function(response) {
		console.log(response);
		if (response) {
			var popup = $(response.html);
			popup.appendTo('body');
			$(document).ready(function() {
				setTimeout(function() {
					initPopup();
				}, 500)
			})
		} else {
			deleteCookie('STYXKEY_CTA_POPUP');
		}
	});

});